import axios from 'axios';

export default {
  find: function (id) {
    return axios.get('/api/organizations/find?id='+id)
  }
}